import { Button, useTheme } from '@mui/material';
import React from 'react';
export const DefaultOutlinedButton = ({ sx, onClick, title, ...rest }) => {
    const theme = useTheme();
    return (React.createElement(Button, { variant: "outlined", disableElevation: true, sx: {
            height: '50px',
            background: 'white',
            borderRadius: '8px',
            letterSpacing: '0.2px',
            textTransform: 'none',
            color: 'secondary.main',
            borderColor: theme.palette.grey[300],
            fontSize: { xs: '0.857rem', sm: '1rem' },
            ...(sx && sx),
        }, onClick: onClick, ...(rest && rest) }, title && title));
};
